<template>
  <div data-test-id="showtimes-button-basic">
    <q-btn
      flat
      :ripple="salesEnabled"
      size="md"
      :padding="compact ? 'xs' : undefined"
      class="showing text-weight-bold text-body1 q-pa-none shadow-1"
      :style="{
        width: isShowtimeGrid ? '100%' : $q.screen.lt.md ? '102px' : '116px',
        opacity: isDisabled ? 0.5 : 1,
        'border-radius': `${borderRadius}px`,
        'pointer-events': !salesEnabled && 'none',
        'min-height': isShowtimeGrid ? '40px' : '70px',
        'background-color': showingBadgesHasCustomColor ? getShowingBadgeColor : '#ffffff'
      }"
      :class="{
        past: showing.localPast,
        current: showing.current,
        'text-red': $register && showing.private && (!showingBadgesHasCustomColor || (showingBadgesHasCustomColor && !$isColorDark(getShowingBadgeColor))),
        'cursor-inherit': !salesEnabled,
        [showing.displayMetaData && showing.displayMetaData.classes]: true,
        'text-dark': !showingBadgesHasCustomColor || (showingBadgesHasCustomColor && !$isColorDark(getShowingBadgeColor)),
        'text-white': showingBadgesHasCustomColor && $isColorDark(getShowingBadgeColor),

      }"
      :disable="isDisabled"
      :data-test-id="`showtimes-button-basic-${isDisabled ? 'disabled' : 'enabled'}`"
      @click="salesEnabled && $emit('select-showing', showing)"
      @contextmenu.prevent="salesEnabled && $emit('show-held-seat-dialog')"
    >
      {{ $d(showing.movieSiteTime, 'shortTime') }}
      <template v-if="salesEnabled">
        <div
          v-if="($register || hasMultipleScreens) && !hideScreenName"
          :class="registerSubtextColor"
          style="font-size: 10px; position: absolute; left: 0; top: -3px; right: 0; margin:0 auto; text-transform: initial;"
        >
          {{ showing.screen.name }}
        </div>
        <div
          v-if="$register"
          :class="registerSubtextColor"
          style="font-size: 10px; position: absolute; right: 4px; bottom: -3px;"
        >
          {{ showing.siteEndTime.format("h:mm a") }}
        </div>
        <q-icon
          v-if="$register && showing.private"
          name="visibility_off"
          :class="registerSubtextColor"
          size="xs"
          style="position: absolute; left: 5px; bottom: 3px;"
        />
      </template>
    </q-btn>

    <q-tooltip
      v-if="isDisabled"
    >
      {{ buttonDisabledMessage }}
    </q-tooltip>
  </div>
</template>
<script>

import Showing from 'src/models/showing/Showing'

export default {
  name: 'ShowtimesButtonBasic',
  props: {
    showing: {
      type: Showing,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: true
    },
    hasMultipleScreens: {
      type: Boolean,
      required: true
    },
    isShowtimeGrid: {
      type: Boolean,
      required: false,
      default: false
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    borderRadius: {
      type: Number,
      required: false,
      default: 3
    },
    hideScreenName: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  configuration: ['currentSite'],
  emits: ['select-showing', 'show-held-seat-dialog'],
  computed: {
    salesEnabled () {
      return this.$register || this.currentSite.hasOnlineTicketing
    },
    buttonDisabledMessage () {
      return this.showing.hasPurchaseEmbargo ? this.$t('showing.ticketsGoOnSale', { time: this.$d(this.showing.embargoPurchaseLiftedAt, 'medium') }) : this.$t('showing.noLongerAvailableForPurchaseOnline')
    },
    showingBadgesHasCustomColor () {
      return _.some(this.showing.showingBadges.data.map(showingBadge => !_.isNil(showingBadge.color)))
    },
    getShowingBadgeColor () {
      if (!this.showingBadgesHasCustomColor) return null

      const conferPriorityColors = _(this.showing.showingBadges.data)
        .filter(showingBadge => showingBadge.conferPriority && !_.isNil(showingBadge.color))
        .map(showingBadge => showingBadge.color)
        .value()

      const colors = _(this.showing.showingBadges.data)
        .filter(showingBadge => !_.isNil(showingBadge.color))
        .map(showingBadge => showingBadge.color)
        .value()

      return conferPriorityColors.length > 0 ? conferPriorityColors[0] : colors[0]
    },
    registerSubtextColor () {
      if (this.$register && this.showing.private && !this.showingBadgesHasCustomColor) {
        return 'text-red'
      } else {
        return this.showingBadgesHasCustomColor && this.$isColorDark(this.getShowingBadgeColor) ? 'text-grey-3' : 'text-grey-6'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.past {
  color: #333;
}
.current {
  color: var(--q-primary);
}

</style>
